import GroupsIcon from "@mui/icons-material/Groups";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import InterpreterModeRoundedIcon from "@mui/icons-material/InterpreterModeRounded";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import Diversity3Icon from '@mui/icons-material/Diversity3';

export function menuDataArray() {
  const menuCollapseData = [
    {
      name: "page_dashboard",
      route: "/dashboard",
      icon: <DashboardRoundedIcon className="icon" />,
    },
    {
      name: "page_provincial_council_member",
      route: "/member-in-mandate",
      icon: <PeopleAltRoundedIcon className="icon" />,
      include: ["/member-in-mandate", "/member-in-mandate/member-details"],
    },
    {
      name: "page_secretarait",
      route: "/secretarait",
      icon: <HistoryEduIcon className="icon" />,
    },
    {
      name: "page_work_group",
      route: "/work-group",
      icon: <Diversity3Icon className="icon" />,
    },
    {
      name: "page_parties_and_candidates",
      route: "/parties-and-candidates",
      icon: <GroupsIcon className="icon" />,
      include: ["/parties-and-candidates", "/parties-and-candidates/member-details"],
    },
    {
      name: "page_laws_and_legislations",
      route: "/laws-and-legislations",
      icon: <MenuBookRoundedIcon className="icon" />,
    },
    {
      name: "page_public_forum",
      route: "/public-forum",
      icon: <InterpreterModeRoundedIcon className="icon" />,
    },

    {
      name: "page_setting",
      route: "/setting",
      icon: <SettingsRoundedIcon className="icon" />,
      include: [
        "/setting/user",
        "/setting/party",
        "/setting/major",
        "/setting/member",
        "/setting/meeting-type",
        "/setting/capital-province",
        "/setting/reason-of-loss-member",
        "/setting/capital-province/district",
        "/setting/council-positions",
        "/setting/member/member-details",
        "/setting/institute-or-university",
      ],
    },
  ];

  return menuCollapseData;
}
